var _defs, _path, _path2, _circle, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoheteBotones(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 203.37 64.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#151518;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Screenshot 2022-04-23 225255") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M247.21,86.91l37.47-16.2s8.66-3,11.06,3.73,6.56,7.85,10.49,7.37S359.94,75,378,92.18L279.18,104l-.33-6.51,6-1.17-.48-4-35.69.6Z",
    transform: "translate(-174.58 -70.05)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M252.12,128.08,292.35,135s9.13.87,9.88-6.22,4.52-9.18,8.46-9.63,53.81-6,67.26-27L279.18,104l1.21,6.4,6.1-.27.47,4L252.14,122Z",
    transform: "translate(-174.58 -70.05)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 141.51,
    cy: 30.13,
    r: 9.06
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M260,104.67l-82.28,2-3.15-23.85s4.26,19.72,24.06,19.77S260,104.67,260,104.67Z",
    transform: "translate(-174.58 -70.05)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M260.35,108l-82.28,2-2,24s3.3-19.91,23.07-20.92S260.35,108,260.35,108Z",
    transform: "translate(-174.58 -70.05)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoheteBotones);
export default __webpack_public_path__ + "static/media/cohete-botones.2f39341dc8f31279d2bc33d5f1569865.svg";
export { ForwardRef as ReactComponent };